/**
 * Which concurrency token a queued Prospect edit sends. An edit carries the token it was built from;
 * when this client's own earlier save has since moved the Prospect on, the edit steps forward through
 * the versions those saves returned — never past one someone else wrote. So a quick second edit
 * doesn't false-conflict on the client's own first one, while another user's edit still makes a stale
 * draft a 409. Keep one instance per mutation hook; record each save's sent and returned tokens.
 */
export class OwnSaveTokens {
  private readonly next = new Map<string, number>();

  /** This client saved the Prospect from `sent` and the server returned `returned`. */
  record(prospectId: string, sent: number, returned: number): void {
    this.next.set(`${prospectId}:${sent}`, returned);
  }

  /** The token to send for an edit built from `builtFrom`. */
  tokenFor(prospectId: string, builtFrom: number): number {
    let token = builtFrom;
    for (let step = this.next.get(`${prospectId}:${token}`); step !== undefined; step = this.next.get(`${prospectId}:${token}`)) {
      token = step;
    }
    return token;
  }
}
